document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.js-tooltip');

  if (elements) {
    elements.forEach(element => {
      const content = element.querySelector('.js-tooltip-content');
      element.addEventListener('mouseenter', () => {
        content.classList.add('is-tooltip-active');
      });
      element.addEventListener('mouseleave', () => {
        content.classList.remove('is-tooltip-active');
      });
    });
  }
});
